import { render, staticRenderFns } from "./CreditNoteForm.vue?vue&type=template&id=a4f6b6b4"
import script from "./CreditNoteForm.vue?vue&type=script&lang=js"
export * from "./CreditNoteForm.vue?vue&type=script&lang=js"
import style0 from "./CreditNoteForm.vue?vue&type=style&index=0&id=a4f6b6b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports